import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ExternalLink extends Component {
	static propTypes = {
		href: PropTypes.string.isRequired,
		text: PropTypes.string.isRequired,
		openInNewTab: PropTypes.bool,
	};

	static defaultProps = {
		openInNewTab: false,
	};

	render() {
		const { href, text, openInNewTab } = this.props;

		return openInNewTab
			? <a href={href} target="_blank" rel="noopener noreferrer">
					{text}
				</a>
			: <a href={href}>
					{text}
				</a>;
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ExternalLink/index.js